import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { Hoverable } from '@/components/shared/redesign/Hoverable';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

interface DesktopPanelTabsProps {
  tabs: string[];
  activeIndex: number;
  onChange: (index: number) => void;
}

export const DesktopPanelTabs: React.FC<DesktopPanelTabsProps> = ({ tabs, activeIndex, onChange }) => {
  const styles = useStyles();

  return (
    <View style={styles.tabContainer}>
      {tabs.map((tab, index) => (
        <Hoverable
          key={tab}
          hover={activeIndex === index ? 'none' : 'row'}
          style={[styles.tab, activeIndex === index && styles.activeTab]}
          onPress={() => onChange(index)}
        >
          <Text style={[styles.tabText, activeIndex === index && styles.activeTabText]}>{tab}</Text>
        </Hoverable>
      ))}
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) => {
    const admin = components.admin;
    return StyleSheet.create({
      tabContainer: {
        backgroundColor: 'transparent',
        borderBottomWidth: 1,
        borderBottomColor: admin.dataTable.border,
        paddingVertical: 12,
        paddingHorizontal: 16,
        flexDirection: 'row',
        gap: 12,
      },
      tab: {
        flex: 1,
        paddingVertical: 8,
        borderRadius: 20,
        backgroundColor: 'transparent',
        alignItems: 'center',
      },
      activeTab: {
        backgroundColor: admin.selector.itemSelectedBg,
      },
      tabText: {
        fontSize: 14,
        fontWeight: '500',
        color: colors.text.dim,
      },
      activeTabText: {
        color: admin.selector.itemSelectedText,
        fontWeight: '600',
      },
    });
  });
